import React, { createContext, useContext } from 'react';
import {
  HookReturnType,
  MenuItemType,
  RoleTypes,
  TRoutes,
  TcolorsPaletteFromBO,
} from './types';

type HeaderContextType = {
  programUrl: string;
  canAccessBo: boolean;
  userRoles: RoleTypes[] | undefined;
  colorsPaletteFromBO: TcolorsPaletteFromBO;
  appLogo: JSX.Element;
  routes: TRoutes;
  menuItems: MenuItemType[];
  isMenuItemsLoading: boolean;
  isStoreEnabled: boolean | undefined;
  userFirstname: string;
  totalRewardsValue?: number;
  t: (value: string) => string;
  useLogout: () => HookReturnType;
  navigate: (url: string) => void;
};

export const HeaderContext = createContext<HeaderContextType>(undefined!);

interface TProps {
  children: JSX.Element;
  programUrl: string;
  canAccessBo: boolean;
  userRoles: RoleTypes[] | undefined;
  colorsPaletteFromBO: TcolorsPaletteFromBO;
  appLogo: JSX.Element;
  routes: TRoutes;
  menuItems: MenuItemType[];
  isMenuItemsLoading: boolean;
  isStoreEnabled: boolean | undefined;
  userFirstname: string;
  totalRewardsValue?: number;
  t: (value: string) => string;
  useLogout: () => HookReturnType;
  navigate: (url: string) => void;
}

const HeaderContextProvider = ({
  children,
  programUrl,
  canAccessBo,
  userRoles,
  colorsPaletteFromBO,
  appLogo,
  routes,
  menuItems,
  isMenuItemsLoading,
  isStoreEnabled,
  userFirstname,
  totalRewardsValue,
  t,
  useLogout,
  navigate,
}: TProps) => {
  return (
    <HeaderContext.Provider
      value={{
        programUrl,
        canAccessBo,
        userRoles,
        colorsPaletteFromBO,
        appLogo,
        routes,
        menuItems,
        isMenuItemsLoading,
        isStoreEnabled,
        userFirstname,
        totalRewardsValue,
        t,
        useLogout,
        navigate,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export default HeaderContextProvider;

export const useHeaderContext = () => {
  return useContext(HeaderContext);
};
